export enum FlagNames {
  CX_IS_STARGATE_CART_SVC_PROXY_ENABLED = 'cx_is_stargate_cart_svc_proxy_enabled',
}

export const flagNames = Object.values(FlagNames)
